import { PB_TYPE_IMAGE, PB_TYPE_CAROUSEL, PB_TYPE_BANNER } from './constants';

function checkIfHasLightboxAndImages(component) {
  const isImage = [PB_TYPE_IMAGE, PB_TYPE_CAROUSEL].includes(component.type);
  const hasEnabledLightbox = isImage && component.settings.enableLightbox;
  const hasEmptyImage = component.type === PB_TYPE_IMAGE && !component.settings.imageId;
  return hasEnabledLightbox && !hasEmptyImage;
}

function getLightboxImages(pageBuilder) {
  const getImage = component => {
    const hasLighboxAndImage = checkIfHasLightboxAndImages(component);

    if (hasLighboxAndImage) {
      if (component.type === PB_TYPE_CAROUSEL) {
        const hasBanner = !!isOnlyChildBanner(component.type, component.items);
        return component.settings.imageIds.map((imageId, index) => {
          const currentElement = {
            ...component.settings,
            imageId,
            hasBanner,
            banner: hasBanner ? component.items[0].settings : null
          };
          delete currentElement.imageIds;
          return currentElement;
        });
      }
      return isOnlyChildBanner(component.type, component.items)
        ? [{ ...component.settings, hasBanner: true, banner: component.items[0].settings }]
        : [component.settings];
    }
    return [];
  };

  const isOnlyChildBanner = (type, items) =>
    [PB_TYPE_IMAGE, PB_TYPE_CAROUSEL].includes(type) &&
    items &&
    items.length === 1 &&
    items[0].type === PB_TYPE_BANNER;

  const getItems = component =>
    !component.items ||
    !component.items.length ||
    isOnlyChildBanner(component.type, component.items)
      ? getImage(component)
      : component.items.map(child => getItems(child));

  const parseImages = container =>
    Array.isArray(container) ? [].concat(...container.map(parseImages)) : container;

  return parseImages(pageBuilder.map(component => getItems(component)));
}

export default getLightboxImages;
